"use client";

import { motion } from "framer-motion";
import Image from "next/image";

interface BoardOfTrusteesSectionProps {
  boardOfTrustees: {
    title: string;
    members: Array<{
      name: string;
      position: string;
      imgUrl: string;
    }>;
  };
}

const BoardOfTrusteesSection = ({
  boardOfTrustees,
}: BoardOfTrusteesSectionProps) => {
  if (!boardOfTrustees?.members || boardOfTrustees.members.length === 0)
    return null;

  return (
    <section className="bg-gradient-to-b from-[#0a4384] to-tertiary py-[3rem] md:py-[5rem] px-[1rem] md:px-[2rem] w-full overflow-hidden">
      <div className="mx-auto max-w-[120rem] w-full">
        <motion.h2
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.45 }}
          className="text-[2rem] sm:text-[2.5rem] md:text-[3rem] lg:text-[4rem] font-bold text-white text-center mb-[3rem] md:mb-[4rem] px-[1rem]"
        >
          {boardOfTrustees?.title}
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-[2rem] md:gap-[3rem]">
          {boardOfTrustees.members.map((member, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.45,
                delay: Math.min(index * 0.025, 0.15),
              }}
              className="bg-white/10 backdrop-blur-sm rounded-[1rem] p-[1.5rem] md:p-[2rem] text-center hover:bg-white/20 transition-colors w-full"
            >
              {member.imgUrl && (
                <div className="relative w-[10rem] h-[10rem] md:w-[12rem] md:h-[12rem] mx-auto mb-[1.5rem] md:mb-[2rem] rounded-full overflow-hidden">
                  <Image
                    src={member.imgUrl || ""}
                    alt={member.name}
                    fill
                    className="object-cover"
                  />
                </div>
              )}
              <h3 className="text-[1.2rem] sm:text-[1.5rem] md:text-[1.8rem] font-bold text-white mb-[0.5rem] break-words">
                {member.name}
              </h3>
              <p className="text-[1rem] sm:text-[1.2rem] md:text-[1.4rem] text-white/80 break-words">
                {member.position}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BoardOfTrusteesSection;
